import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { motion } from "framer-motion";
import Image from "next/image";
import bgImage from "../../assets/salontymindia_cover.jpeg";
import LaunchIcon from "@mui/icons-material/Launch";
import YouTubeIcon from "@mui/icons-material/YouTube";

const ctaSx = {
  borderRadius: "999px",
  textTransform: "capitalize" as const,
  px: 3,
  py: 1.25,
  background: "linear-gradient(135deg, #123524 0%, #1f7a4d 100%)",
  boxShadow: "0 8px 24px rgba(18, 53, 36, 0.2)",
  "&:hover": {
    background: "linear-gradient(135deg, #0f2d1f 0%, #1a6b42 100%)",
  },
};

const videos = [
  {
    id: "1",
    title: "Video 1",
    url: "https://www.youtube.com/embed/0dnc-LkFL2o?si=esQWaiovHDutmehy",
  },
  {
    id: "2",
    title: "Video 2",
    url: "https://www.youtube.com/embed/eXxAQ3JLgYE?si=IdaqbVwoWyM1Wv9P",
  },
  {
    id: "3",
    title: "Video 3",
    url: "https://www.youtube.com/embed/oJ9kyrtjLR8?si=4r0fxMx3nRJOSp7b",
  },
];

const MediaYouTube: React.FC = () => {
  return (
    <Box sx={{ marginTop: { xs: 0, sm: "1rem" } }}>
      <Box sx={{ position: "relative", width: "100%", overflow: "hidden", borderRadius: { xs: 0, sm: 2 } }}>
        <Image
          src={bgImage}
          width={2000}
          height={1000}
          alt="SalonTym YouTube channel"
          style={{ objectFit: "cover", width: "100%", height: "auto", display: "block" }}
        />
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(180deg, transparent 40%, rgba(18, 53, 36, 0.45) 100%)",
            pointerEvents: "none",
            borderRadius: { xs: 0, sm: 2 },
          }}
        />
      </Box>

      <Container maxWidth="lg" sx={{ mt: 4, textAlign: "center", px: { xs: 2, sm: 3 } }}>
        <Typography
          variant="h4"
          component="h2"
          gutterBottom
          sx={{
            fontWeight: 700,
            color: "#123524",
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          Featured
          <Box
            component="span"
            sx={{
              color: "#c00",
              display: "inline-flex",
              alignItems: "center",
              gap: 0.5,
            }}
          >
            <YouTubeIcon sx={{ fontSize: { xs: "2rem", sm: "2.5rem" } }} />
            YouTube
          </Box>
          videos
        </Typography>
        <br />
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          style={{
            display: "flex",
            overflowX: "auto",
            gap: "20px",
            paddingBottom: "10px",
            scrollbarWidth: "none",
          }}
        >
          {videos.map((video, index) => (
            <motion.div
              key={video.id}
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              style={{ minWidth: "350px", flex: "0 0 auto" }}
            >
              <iframe
                width="100%"
                height="200"
                src={video.url}
                title={video.title}
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
                style={{
                  borderRadius: "12px",
                  border: "1px solid rgba(18, 53, 36, 0.12)",
                  boxShadow: "0 8px 24px rgba(18, 53, 36, 0.1)",
                }}
              ></iframe>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.9 }}
          style={{ marginTop: "20px" }}
        >
          <Button
            variant="contained"
            size="large"
            href="https://www.youtube.com/@Salontym"
            target="_blank"
            rel="noopener noreferrer"
            endIcon={<LaunchIcon />}
            sx={ctaSx}
          >
            Check out more
          </Button>
        </motion.div>
      </Container>
    </Box>
  );
};

export default MediaYouTube;
